import { render, staticRenderFns } from "./left-bar.vue?vue&type=template&id=2b9d454a&scoped=true&"
import script from "./left-bar.vue?vue&type=script&lang=js&"
export * from "./left-bar.vue?vue&type=script&lang=js&"
import style0 from "./left-bar.vue?vue&type=style&index=0&id=2b9d454a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d454a",
  null
  
)

export default component.exports